
import { keyValueList } from "../../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { ramTablesLevelProps, centerAlignStyle, ramTableLevelProps, screenHeight, calcWaveformAndScrollBarHeight, ramTableRowStyle } from "./WaveSimStyle.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import * as react from "react";
import { isReadOnlyMemory, addressReadAt } from "./EvilHoverCache.js";
import { head, tail, isEmpty as isEmpty_1, insertAt, item as item_1, ofArray, length, filter, pairwise, singleton as singleton_1, collect, concat, sort, empty as empty_1, cons, sortBy, tryFind, map } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { int32ToString, comparePrimitives, compareArrays, equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { ofFastSim, RamView, RamRow, RamRowType } from "../../Simulator/FastSim/RamView.js";
import { op_Division, fromInt32, op_Addition, fromOne, op_LeftShift, op_Subtraction, op_BitwiseAnd, compare, fromZero, equals as equals_1 } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { getFastSim } from "../../Simulator/Simulator.js";
import { SimulatedDesign__ComponentOfInstance_6546966D } from "../../Simulator/SimTypes.js";
import { printf, concat as concat_1, toFail } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { ofInstanceCached } from "../../Simulator/FastSim/PortView.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.13.0/Option.js";
import { PortType } from "../../Common/CommonTypes.js";
import { valToPaddedString } from "../../Simulator/NumberHelpers.js";
import { Optics_snd_, Optics_fst_, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89 } from "../../Common/Optics.js";
import { ramStartLocation_ } from "../../Model/ModelType.js";
import { inputBigint, ModelLocations, waveSimModel_ } from "../ModelHelpers.js";
import { toList as toList_1, isEmpty, empty as empty_2, add, tryFind as tryFind_1 } from "../../fable_modules/fable-library-js.5.13.0/Map.js";
import { heldAny, keyOf } from "./RamData.js";
import { maxRamRowsDisplayed } from "./WaveSimTypes.js";
import { dbg, warn } from "../../Shared/Log.js";
import { min, max } from "../../fable_modules/fable-library-js.5.13.0/Double.js";
import { CSSProp, HTMLAttr } from "../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Item_Option, item as item_2 } from "../../fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { Option, h6 } from "../../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { TableOption, table as table_1 } from "../../fable_modules/Fulma.3.0.0/Elements/Table.fs.js";
import { getTimeMs, instrumentInterval } from "../../Common/TimeHelpers.js";

/**
 * Table row that shows the address and data of a RAM component, and what the .ram file it was
 * initialised from had to say about that location. The comment column is there only when the
 * memory has comments, so that every row of a table has the same cells.
 */
export function ramTableRow(hasComments, _arg1_, _arg1__1, _arg1__2, _arg1__3) {
    const _arg = [_arg1_, _arg1__1, _arg1__2, _arg1__3];
    const props_6 = [["style", keyValueList(ramTableRowStyle(_arg[3]), 1)]];
    const children_6 = toList(delay(() => append(singleton(react.createElement("td", {}, _arg[0])), delay(() => append(singleton(react.createElement("td", {}, _arg[1])), delay(() => {
        let props_4;
        return hasComments ? singleton((props_4 = [["style", {
            color: "grey",
        }]], react.createElement("td", keyValueList(props_4, 1), _arg[2]))) : empty();
    }))))));
    return react.createElement("tr", keyValueList(props_6, 1), ...children_6);
}

function markReadLocally(fs, ram_, ram__1, step, view) {
    const ram = [ram_, ram__1];
    const matchValue = addressReadAt(fs, ram[0], ram[1], step);
    if (matchValue != null) {
        const address = matchValue;
        const mark = (rows) => {
            const cleared = map((row) => {
                if (equals(row.Row, RamRowType.RAMRead)) {
                    return new RamRow(row.Addr, row.Value, RamRowType.RAMNormal);
                }
                else {
                    return row;
                }
            }, rows);
            const matchValue_1 = tryFind((row_1) => equals_1(row_1.Addr, address), cleared);
            if (matchValue_1 == null) {
                return sortBy((row_3) => row_3.Addr, cons(new RamRow(address, fromZero(), RamRowType.RAMRead), cleared), {
                    Compare: (x, y) => (compare(x, y) | 0),
                });
            }
            else {
                return map((row_2) => {
                    if (equals_1(row_2.Addr, address)) {
                        return new RamRow(row_2.Addr, row_2.Value, RamRowType.RAMRead);
                    }
                    else {
                        return row_2;
                    }
                }, cleared);
            }
        };
        if (view.tag === 1) {
            return new RamView(/* RamWindow */ 1, [view.fields[0], mark(view.fields[1])]);
        }
        else {
            return new RamView(/* RamSparse */ 0, [mark(view.fields[0])]);
        }
    }
    else {
        return view;
    }
}

/**
 * Table showing contents of a RAM component.
 */
export function ramTable(dispatch, wsModel, model, _arg1_, _arg1__1) {
    let l_4, l_6, _arg_2, heldKey_1, rows_2, rows_3, rows_5, start_1, rows_4, items, start_2, ad, items_1, props_19, children_16, children_12, children_10, children_14;
    const _arg = [_arg1_, _arg1__1];
    const ramLabel = _arg[1];
    const ramId = _arg[0];
    const wanted = calcWaveformAndScrollBarHeight(wsModel);
    const fs = getFastSim();
    const matchValue = SimulatedDesign__ComponentOfInstance_6546966D(fs.Design, ramId);
    if (matchValue != null) {
        const comp = matchValue;
        const step = wsModel.CursorExactClkCycle | 0;
        let mem;
        const matchValue_1 = comp.Type;
        let matchResult, m;
        switch (matchValue_1.tag) {
            case 40: {
                matchResult = 0;
                m = matchValue_1.fields[0];
                break;
            }
            case 39: {
                matchResult = 0;
                m = matchValue_1.fields[0];
                break;
            }
            case 41: {
                matchResult = 0;
                m = matchValue_1.fields[0];
                break;
            }
            case 42: {
                matchResult = 0;
                m = matchValue_1.fields[0];
                break;
            }
            default:
                matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                mem = m;
                break;
            }
            default:
                mem = toFail(`Given a component ${comp.Type} which is not a vaild RAM`);
        }
        let patternInput;
        const ports = ofInstanceCached(fs, ramId[1]).ViewPorts;
        const widthOf = (portType, num) => {
            const option_1 = tryFind((p) => {
                if (equals(p.PortComp, ramId[0]) && equals(p.PortIs, portType)) {
                    return p.PortNum === num;
                }
                else {
                    return false;
                }
            }, ports);
            if (option_1 != null) {
                return option_1.PortWidth;
            }
            else {
                return undefined;
            }
        };
        patternInput = [defaultArg(widthOf(PortType.Input, 0), mem.AddressWidth), defaultArg(widthOf(PortType.Output, 0), mem.WordWidth)];
        const dWidth = patternInput[1] | 0;
        const aWidth = patternInput[0] | 0;
        const print = (w, a) => valToPaddedString(w, wsModel.Radix, op_BitwiseAnd(op_Subtraction(op_LeftShift(fromOne(), w), fromOne()), a));
        const lastLocation = op_Subtraction(op_LeftShift(fromOne(), aWidth), fromOne());
        const opticPath = (fc) => {
            let defaultVal, k;
            const l_2 = Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, ramStartLocation_)(waveSimModel_);
            return Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, (defaultVal = ["", fromZero()], (k = fc, [(arg_2) => {
                const _arg_1 = tryFind_1(k, arg_2);
                return (_arg_1 == null) ? defaultVal : _arg_1;
            }, (v_1) => ((x) => add(k, v_1, x))])))(l_2);
        };
        const loc = new ModelLocations((l_4 = opticPath(ramId), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, Optics_fst_())(l_4)), (l_6 = opticPath(ramId), Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, Optics_snd_())(l_6)));
        const key = keyOf(model, ramId[0], ramId[1]);
        let patternInput_1;
        if (model.SimulateInRenderer) {
            patternInput_1 = [(_arg_2 = ofFastSim(fs, ramId[0], ramId[1], step, key.SparseUpTo, key.Start, maxRamRowsDisplayed), (_arg_2.tag === 1) ? ((warn(`reading RAM '${ramLabel}' at cycle ${step}: ${_arg_2.fields[0]}`), undefined)) : _arg_2.fields[0]), step];
        }
        else {
            const matchValue_2 = heldAny(model, ramId[0], ramId[1]);
            patternInput_1 = ((matchValue_2 != null) ? (((matchValue_2[1], matchValue_2[0], !isReadOnlyMemory(fs, ramId[0], ramId[1]))) ? ((heldKey_1 = matchValue_2[0], (rows_2 = matchValue_2[1], [rows_2, heldKey_1.Cycle]))) : ((rows_3 = matchValue_2[1], [markReadLocally(fs, ramId[0], ramId[1], step, rows_3), step]))) : [undefined, step]);
        }
        const view = patternInput_1[0];
        const patternInput_2 = (view == null) ? [key.Start, true, empty_1()] : ((view.tag === 1) ? ((rows_5 = view.fields[1], (start_1 = view.fields[0], [start_1, true, rows_5]))) : ((rows_4 = view.fields[0], [fromZero(), false, rows_4])));
        const windowedDisplay = patternInput_2[1];
        const startDisplayLoc = patternInput_2[0];
        const maxHeight = max((screenHeight() - min(wanted, screenHeight() / 2)) - 300, 30) - 40;
        const comments = defaultArg(mem.Comments, empty_2({
            Compare: (x_1, y) => (compare(x_1, y) | 0),
        }));
        const hasComments = !isEmpty(comments);
        const print1 = (tupledArg) => {
            const a_1 = tupledArg[0];
            return [print(aWidth, a_1), print(dWidth, tupledArg[1]), defaultArg(tryFind_1(a_1, comments), ""), tupledArg[2]];
        };
        let lineItems;
        const triples = map((r) => [r.Addr, r.Value, r.Row], patternInput_2[2]);
        lineItems = (windowedDisplay ? map(print1, sortBy((tupledArg_3) => {
            let loc_1;
            if ((loc_1 = tupledArg_3[0], (compare(loc_1, startDisplayLoc) >= 0) && (compare(loc_1, op_Addition(startDisplayLoc, fromInt32(maxRamRowsDisplayed))) < 0))) {
                return 0;
            }
            else {
                return 1;
            }
        }, sort(triples, {
            Compare: (x_2, y_1) => (compareArrays(x_2, y_1) | 0),
        }), {
            Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
        })) : concat(collect((tupledArg_2) => {
            const _arg_4 = tupledArg_2[1];
            const gEnd_1 = _arg_4[0];
            const thisItem = equals_1(gEnd_1, op_Addition(lastLocation, fromOne())) ? empty_1() : singleton_1(print1([gEnd_1, _arg_4[1], _arg_4[2]]));
            return toList(delay(() => {
                let gStart, gEnd, gapSize, d;
                return append(singleton((gStart = tupledArg_2[0][0], (gEnd = gEnd_1, (gapSize = op_Subtraction(gEnd, gStart), (equals_1(gapSize, fromOne()) ? true : windowedDisplay) ? empty_1() : (equals_1(gapSize, fromInt32(2)) ? singleton_1(print1([op_Division(op_Addition(gEnd, gStart), fromInt32(2)), fromZero(), RamRowType.RAMNormal])) : ((compare(gapSize, fromInt32(2)) > 0) ? singleton_1((d = fromZero(), [concat_1(print(aWidth, op_Addition(gStart, fromOne())), " ... ", print(aWidth, op_Subtraction(gEnd, fromOne()))), print(dWidth, d), "", RamRowType.RAMNormal])) : toFail(`What? gEnd=${gEnd},gStart=${gStart}: negative or zero gaps are impossible...`))))))), delay(() => singleton(thisItem)));
            }));
        }, pairwise((items = sort(filter((tupledArg_4) => {
            if (!equals_1(tupledArg_4[1], fromZero())) {
                return true;
            }
            else {
                return !equals(tupledArg_4[2], RamRowType.RAMNormal);
            }
        }, triples), {
            Compare: (x_4, y_3) => (compareArrays(x_4, y_3) | 0),
        }), (start_2 = fromZero(), (ad = ((tupledArg_1) => tupledArg_1[0]), (length(items) === 0) ? ofArray([[fromInt32(-1), fromZero(), RamRowType.RAMNormal], [lastLocation, fromZero(), RamRowType.RAMNormal]]) : ((items_1 = ((compare(ad(item_1(0, items)), start_2) < 0) ? items : insertAt(0, [op_Subtraction(start_2, fromOne()), op_Subtraction(start_2, fromOne()), RamRowType.RAMNormal], items)), (equals_1(ad(item_1(length(items_1) - 1, items_1)), lastLocation) ? true : windowedDisplay) ? items_1 : insertAt(length(items_1), [op_Addition(lastLocation, fromOne()), fromZero(), RamRowType.RAMNormal], items_1))))))))));
        const inputBox = inputBigint(ofArray([["style", {
            width: 200,
        }], new HTMLAttr(/* AutoFocus */ 55, [false])]), "Window Start", loc, (big_1, _arg_7) => {
            let big;
            return ((big = big_1, ((compare(big, fromZero()) >= 0) && (compare(big, lastLocation) <= 0)) ? "" : (`Address ${big} is out of required range: 0 - ${lastLocation}`))) === "";
        }, dispatch, model);
        return item_2(ofArray([new Item_Option(/* Props */ 0, [ramTableLevelProps]), Item_Option.HasTextCentered]), ofArray([h6(singleton_1(new Option(/* Props */ 9, [singleton_1(centerAlignStyle)])))(ofArray([ramLabel, react.createElement("br", {}), inputBox])), (props_19 = [["style", {
            maxHeight: maxHeight,
            overflowY: "auto",
        }]], (children_16 = [table_1(ofArray([TableOption.IsFullWidth, TableOption.IsBordered]), ofArray([(children_12 = [(children_10 = toList(delay(() => append(singleton(react.createElement("th", keyValueList([centerAlignStyle], 1), "Address")), delay(() => {
            let children_6, props_7, children_4;
            return append(singleton((children_6 = ["Data", (props_7 = [["style", {
                marginLeft: "2px",
                fontSize: "10px",
            }]], (children_4 = [int32ToString(patternInput_1[1])], react.createElement("sub", keyValueList(props_7, 1), ...children_4)))], react.createElement("th", keyValueList([centerAlignStyle], 1), ...children_6))), delay(() => (hasComments ? singleton(react.createElement("th", keyValueList([centerAlignStyle], 1), "Comment")) : empty())));
        })))), react.createElement("tr", {}, ...children_10))], react.createElement("thead", {}, ...children_12)), (children_14 = map((item) => ramTableRow(hasComments, item[0], item[1], item[2], item[3]), lineItems), react.createElement("tbody", {}, ...children_14))]))], react.createElement("div", keyValueList(props_19, 1), ...children_16))), react.createElement("br", {})]));
    }
    else {
        return react.createElement("div", {});
    }
}

/**
 * Bulma Level component of tables showing RAM contents.
 */
export function ramTables(dispatch, wsModel, model) {
    return instrumentInterval("ramTables", getTimeMs(), (() => {
        let tables, children_11, children_7, props_5, children_5, props_9, props_13, props_15;
        try {
            const inlineStyle = (styles) => {
                const props = singleton_1(["style", keyValueList(cons(new CSSProp(/* Display */ 125, ["inline"]), styles), 1)]);
                return (children) => react.createElement("div", keyValueList(props, 1), ...children);
            };
            const selectedRams = toList_1(wsModel.SelectedRams);
            if (length(selectedRams) > 0) {
                let tables_1;
                let headerRow;
                const _arg = map((tupledArg) => {
                    const arg_1 = singleton_1(inlineStyle(ramTableRowStyle(tupledArg[1]))([tupledArg[0]]));
                    return inlineStyle(singleton_1(new CSSProp(/* Margin */ 218, ["0px"])))(arg_1);
                }, ofArray([["read", RamRowType.RAMRead], ["overwritten", RamRowType.RAMWritten]]));
                let matchResult, a, b, x;
                if (!isEmpty_1(_arg)) {
                    if (!isEmpty_1(tail(_arg))) {
                        if (isEmpty_1(tail(tail(_arg)))) {
                            matchResult = 0;
                            a = head(_arg);
                            b = head(tail(_arg));
                        }
                        else {
                            matchResult = 1;
                            x = _arg;
                        }
                    }
                    else {
                        matchResult = 1;
                        x = _arg;
                    }
                }
                else {
                    matchResult = 1;
                    x = _arg;
                }
                switch (matchResult) {
                    case 0: {
                        headerRow = ofArray(["Key: Memory location is ", a, ", or ", b, ". Click waveforms or use cursor control to change current cycle."]);
                        break;
                    }
                    default: {
                        warn(`unexpected header row in ramTables: ${x}`);
                        headerRow = toFail(printf("What? Can\'t happen!"));
                    }
                }
                tables_1 = table_1(ofArray([new TableOption(/* Props */ 6, [ramTablesLevelProps]), TableOption.IsFullWidth, TableOption.IsBordered]), (tables = map((ram) => {
                    const props_3 = [["style", {
                        borderColor: "white",
                    }]];
                    const children_3 = [ramTable(dispatch, wsModel, model, ram[0], ram[1])];
                    return react.createElement("td", keyValueList(props_3, 1), ...children_3);
                }, selectedRams), singleton_1((children_11 = [(children_7 = [(props_5 = [new HTMLAttr(/* ColSpan */ 67, [length(selectedRams)])], (children_5 = [inlineStyle(empty_1())(headerRow)], react.createElement("th", keyValueList(props_5, 1), ...children_5)))], react.createElement("tr", {}, ...children_7)), (props_9 = [["style", {
                    border: "10px",
                }]], react.createElement("tr", keyValueList(props_9, 1), ...tables))], react.createElement("tbody", {}, ...children_11)))));
                const children_14 = [(props_13 = [["style", {
                    margin: "5px",
                }]], react.createElement("hr", keyValueList(props_13, 1))), (props_15 = [["style", {
                    margin: "0px",
                }]], react.createElement("br", keyValueList(props_15, 1))), tables_1];
                return react.createElement("div", {
                    id: "TablesDiv",
                }, ...children_14);
            }
            else {
                return react.createElement("div", {});
            }
        }
        catch (e) {
            dbg(64, concat_1("RAM table drawn before the simulation finished: ", e.message));
            return react.createElement("div", {});
        }
    })());
}

